// Port of api/fuel/app/classes/filter/search/games/rules/query/last_played.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'last_played',
	field: function() { return 'MAX(p.play_date)' }
})
